<template>
  <div>
    <div class="ft-16 font-bold mb15">Activity</div>
    <div class="row">
      <div class="col-xl-3 col-sm-6">
        <a @click.prevent="$router.push({
          name: 'Schedule',
          params: {
            tab: 'inv'
          }
        })" href="#" class="box-item-dasboard p20 mb30">
          <div class="icon-bid">
            <img src="@/assets/img/icon-invitation.png" class="img-fluid">
          </div>
          <div class="name-bid">
            <div class="for-total">
              <div class="for-number">{{ activity?.new_invitation }}</div>
              <div class="deco"></div>
            </div>
            <div class="desc-bid">
              New Invitation
            </div>
          </div>
        </a>
      </div>
      <div class="col-xl-3 col-sm-6">
        <router-link to="/feedback" class="box-item-dasboard p20 mb30">
          <div class="icon-bid">
            <img src="@/assets/img/icon-comment.png" class="img-fluid">
          </div>
          <div class="name-bid">
            <div class="for-total">
              <div class="for-number">{{ activity?.new_comment_and_feedback }}</div>
              <div class="deco"></div>
            </div>
            <div class="desc-bid">
              New Complaint and Feedback
            </div>
          </div>
        </router-link>
      </div>
      <div class="col-xl-3 col-sm-6">
        <router-link to="/feedback" class="box-item-dasboard p20 mb30">
          <div class="icon-bid">
            <img src="@/assets/img/icon-users.png" class="img-fluid">
          </div>
          <div class="name-bid">
            <div class="for-total">
              <div class="for-number">{{ activity?.montly_visit_user }}</div>
              <div class="deco"></div>
            </div>
            <div class="desc-bid">
              Total Visit User {{ moment().format('MMMM YYYY') }}
            </div>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: "DashboardActivity",
  props: ['activity'],
  data() {
    return {
      moment
    }
  }
}
</script>
